import { THEME } from 'styles/themes';

export const colors = THEME.Countdown.colors ?? {};

export const typography = THEME.Countdown.typography ?? {};

export const options = THEME.Countdown.options ?? {};
